import { useState } from "react";
import { toast } from "sonner";
import { Handshake, EnvelopeSimple, WarningCircle } from "@phosphor-icons/react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field, NativeSelect } from "@/components/common";
import { api, errMsg, money, todayStr } from "@/lib/api";

export default function BulkReconciliationDialog({ open, onOpenChange }) {
  const [asOf, setAsOf] = useState(todayStr());
  const [type, setType] = useState("");
  const [busy, setBusy] = useState(false);
  const [preview, setPreview] = useState(null);
  const [result, setResult] = useState(null);

  const run = async (isPreview) => {
    setBusy(true);
    try {
      const { data } = await api.post("/reconciliations/bulk", { as_of: asOf, type: type || null, preview: isPreview });
      if (isPreview) setPreview(data); else { setResult(data); toast.success(`${data.sent.length} mutabakat mektubu gönderildi`); }
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };

  const d = result || preview;
  return (
    <Dialog open={open} onOpenChange={(o) => { onOpenChange(o); if (!o) { setPreview(null); setResult(null); } }}>
      <DialogContent className="max-w-2xl rounded-[6px]" data-testid="bulk-reconciliation-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-display"><Handshake weight="fill" className="text-[#2dd4bf]" /> Toplu Mutabakat</DialogTitle>
          <DialogDescription>Seçilen tarihte açık bakiyesi olan ve e-postası bulunan tüm carilere mutabakat mektubu gönderilir. Önce önizleyin.</DialogDescription>
        </DialogHeader>
        <div className="grid gap-3 sm:grid-cols-3">
          <Field label="Mutabakat tarihi"><Input type="date" value={asOf} onChange={(e) => { setAsOf(e.target.value); setPreview(null); }} data-testid="bulk-reconciliation-date-input" /></Field>
          <Field label="Cari türü">
            <NativeSelect value={type} onChange={(e) => { setType(e.target.value); setPreview(null); }} data-testid="bulk-reconciliation-type-select">
              <option value="">Tümü</option><option value="customer">Müşteriler</option><option value="supplier">Tedarikçiler</option>
            </NativeSelect>
          </Field>
          <div className="flex items-end"><Button variant="outline" onClick={() => run(true)} disabled={busy} className="w-full rounded-[4px]" data-testid="bulk-reconciliation-preview-button">{busy && !result ? "Hesaplanıyor…" : "Önizle"}</Button></div>
        </div>
        {d && (
          <div className="space-y-3 text-sm" data-testid="bulk-reconciliation-summary">
            <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
              {[["Gönderilecek", d.sent.length, "text-teal-700", "bulk-count-sent"], ["E-postası yok", d.no_email.length, "text-orange-700", "bulk-count-noemail"], ["Zaten bekliyor", d.already_sent.length, "text-slate-600", "bulk-count-pending"], ["Bakiyesi sıfır", d.zero_balance, "text-slate-500", "bulk-count-zero"]].map(([l, n, c, t]) => (
                <div key={l} className="border p-2 text-center"><div className={`font-num text-xl font-bold ${c}`} data-testid={t}>{n}</div><div className="text-[11px] text-muted-foreground">{l}</div></div>
              ))}
            </div>
            <div className="max-h-48 overflow-y-auto border">
              {d.sent.map((a) => <div key={a.id} className="flex justify-between border-b px-3 py-1.5 last:border-0"><span className="flex items-center gap-1.5"><EnvelopeSimple className="text-teal-600" /> {a.name} <span className="text-xs text-muted-foreground">{a.email}</span></span><span className="font-num">{money(Math.abs(a.balance))}</span></div>)}
              {d.no_email.map((a) => <div key={a.id} className="flex justify-between border-b bg-orange-50 px-3 py-1.5 last:border-0"><span className="flex items-center gap-1.5"><WarningCircle className="text-orange-600" /> {a.name} <span className="text-xs text-orange-700">e-posta eksik</span></span><span className="font-num">{money(Math.abs(a.balance))}</span></div>)}
              {d.failed?.map((a) => <div key={a.id} className="flex justify-between border-b bg-red-50 px-3 py-1.5 last:border-0"><span>{a.name} <span className="text-xs text-red-700">{a.error}</span></span></div>)}
            </div>
            {!result && <Button onClick={() => run(false)} disabled={busy || d.sent.length === 0} className="w-full rounded-[4px] font-bold" data-testid="bulk-reconciliation-send-button">{busy ? "Gönderiliyor…" : `${d.sent.length} cariye mutabakat gönder`}</Button>}
            {result && <p className="text-center text-xs text-teal-700" data-testid="bulk-reconciliation-done">Gönderim tamamlandı. Yanıtlar cari detay sayfalarındaki Mutabakat panelinde görünür.</p>}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
